module.exports = __webpack_public_path__ + "static/media/dark-modulo-configurador.4c16b463.svg";